// extracted by mini-css-extract-plugin
module.exports = {"feedbackQuickReplies":"FeedbackQuickReplies_feedbackQuickReplies__DoVHu","hidden":"FeedbackQuickReplies_hidden__rh4jY"};